import { createSlice } from "@reduxjs/toolkit";
import ModulEnum from "src/enums/ModulEnum";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { GridFilterModel } from "@mui/x-data-grid-premium";

interface ISablonTanim {
    sablonEkleOpen: boolean;
    modul: ModulEnum;
    yetkiliRaporId: number;
    sablonAktarGridFilterModel: GridFilterModel;
    icdTanimDialog:boolean;
};
export const SablonTanimSlice = createSlice<ISablonTanim, MapReducerPayloads<ISablonTanim, {
    setSablonEkleOpen: boolean;
    setModul: ModulEnum;
    setYetkiliRaporId: number;
    setSablonAktarGridFilterModel: GridFilterModel;
    setIcdTanimDialog:boolean;
}>>({
    name: "sablonTanim",
    initialState: {
        sablonEkleOpen: false,
        modul: ModulEnum.Patoloji,
        yetkiliRaporId: 0,
        sablonAktarGridFilterModel: { items: [], },
        icdTanimDialog:false,
    },
    reducers: {
        setSablonEkleOpen: (state, action) => {
            state.sablonEkleOpen = action.payload;
        },
        setModul: (state, action) => {
            state.modul = action.payload;
        },
        setYetkiliRaporId: (state, action) => {
            state.yetkiliRaporId = action.payload;
        },
        setSablonAktarGridFilterModel: (state, action) => {
            state.sablonAktarGridFilterModel = action.payload;
        },
        setIcdTanimDialog: (state, action) => {
            state.icdTanimDialog = action.payload;
        },
    }
});